import * as React from "react";
const SvgRefreshClock = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.00073 12.401C4.00073 17.0402 7.76154 20.801 12.4007 20.801C17.0399 20.801 20.8007 17.0402 20.8007 12.401C20.8007 7.76178 17.0399 4.00098 12.4007 4.00098C9.89188 4.00098 7.63992 5.10086 6.10073 6.84475C6.01248 6.94473 5.92657 7.04684 5.84309 7.15098M12.4007 8.20098V12.401L15.0257 15.026M5.84233 4.00508V7.15508H8.99233",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgRefreshClock;
